import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./pages/Home";
import AvailableBikes from "./pages/AvailableBikes";
import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Navbar from "./components/Navbar";
import BookingPage from "./pages/BookingPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import MyBookings from "./pages/MyBookings";
import ContactSupport from "./pages/ContactSupport";
import Profile from "./pages/Profile";
import ShopLocation from "./pages/ShopLocation";
import PickupInstructions from "./pages/PickupInstructions";
import WhatsAppButton from "./components/WhatsAppButton"; // ✅ STEP 3
import DamagePolicy from "./pages/DamagePolicy";
import AboutUs from "./pages/AboutUs";
import ReviewPage from "./pages/ReviewPage";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import CartDrawer from "./components/CartDrawer";


// ADMIN
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import ManageBikes from "./admin/ManageBikes";
import AddBike from "./admin/AddBike";
import ManageBookings from "./admin/ManageBookings";
import ManageUsers from "./admin/ManageUsers";
import EditBike from "./admin/EditBike";
import ManagePriceOverrides from "./admin/ManagePriceOverrides";

function App() {
  const location = useLocation();

  // Hide navbar + WhatsApp on admin pages
  const hideNavbar = location.pathname.startsWith("/admin");

  return (
    <>
      <ToastContainer position="top-right" theme="dark" />
      <ScrollToTop />
      {/* USER NAVBAR */}
      {!hideNavbar && <Navbar />}

      {/* CART DRAWER — global, available from any page */}
      {!hideNavbar && <CartDrawer />}

      <Routes>
        {/* USER ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/available-bikes" element={<AvailableBikes />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/contact-support" element={<ContactSupport />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/shop-location" element={<ShopLocation />} />
        <Route path="/pickup-instructions" element={<PickupInstructions />} />
        <Route path="/damage-policy" element={<DamagePolicy />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/review/:bookingId" element={<ReviewPage />} />


        {/* ADMIN ROUTES */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="bikes" element={<ManageBikes />} />
          <Route path="add-bike" element={<AddBike />} />
          <Route path="bookings" element={<ManageBookings />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="edit-bike/:id" element={<EditBike />} />
          <Route path="price-overrides" element={<ManagePriceOverrides />} />
        </Route>
      </Routes>

      {/* FOOTER */}
      {!hideNavbar && <Footer />}

      {/* ✅ Floating WhatsApp Support */}
      {!hideNavbar && <WhatsAppButton />}
    </>
  );
}

export default App;
